import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./AnimatedCursor.css";

const AnimatedCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768 || "ontouchstart" in window);
    };

    const moveCursor = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    document.addEventListener("mousemove", moveCursor);

    return () => {
      window.removeEventListener("resize", checkMobile);
      document.removeEventListener("mousemove", moveCursor);
    };
  }, []);

  if (isMobile) return null; // Disable cursor on mobile

  return (
    <>
      {/* Inner dot */}
      <motion.div
        className="cursor-dot"
        animate={{ x: position.x, y: position.y }}
        transition={{ type: "spring", stiffness: 500, damping: 28 }}
      />

      {/* Outer ring */}
      <motion.div
        className="cursor-ring"
        animate={{ x: position.x, y: position.y }}
        transition={{ type: "spring", stiffness: 100, damping: 18 }}
      />
    </>
  );
};

export default AnimatedCursor;
